module.exports = __webpack_public_path__ + "assets/img/report-repay-pp-bg.81bcfd2c.png";